// theme.js
import { createTheme } from '@mui/material/styles';

const Font = createTheme({
  typography: {
    fontFamily: '"Inter", sans-serif', // Correct font family
  },
  // Add other theme customizations if needed
});

export default Font;
